import firebase from 'firebase/compat/app';
import 'firebase/compat/firestore';

const getDb = () => firebase.firestore();

const requireTenantId = (tenantId) => {
  if (!tenantId) {
    throw new Error('tenantId is required for Branding & Marketing Suite refs.');
  }
  return tenantId;
};

export const franchiseRoot = (tenantId) =>
  getDb().collection('franchises').doc(requireTenantId(tenantId));

export const brandKitDoc = (tenantId) =>
  franchiseRoot(tenantId).collection('brandKit').doc('main');

export const templatesCollection = (tenantId) =>
  franchiseRoot(tenantId).collection('templates');

export const templateDoc = (tenantId, templateId) =>
  templatesCollection(tenantId).doc(templateId);

export const templateVersionsCollection = (tenantId, templateId) =>
  templateDoc(tenantId, templateId).collection('versions');

export const templateVersionDoc = (tenantId, templateId, versionId) =>
  templateVersionsCollection(tenantId, templateId).doc(versionId);

export const assetsCollection = (tenantId) =>
  franchiseRoot(tenantId).collection('assets');

export const assetDoc = (tenantId, assetId) =>
  assetsCollection(tenantId).doc(assetId);

export const linksCollection = (tenantId) =>
  franchiseRoot(tenantId).collection('links');

export const linkDoc = (tenantId, linkId) =>
  linksCollection(tenantId).doc(linkId);

export const eventsCollection = (tenantId) =>
  franchiseRoot(tenantId).collection('events');

export const eventDoc = (tenantId, eventId) =>
  eventsCollection(tenantId).doc(eventId);
